import React, { useMemo } from "react";
import LanderRouter from "./landers/LanderRouter";
import { LanderConfigProvider } from "./commons/ConfigContext";
import {
  createLanderConfig,
  getApiUrl,
  parseLanderQueryParam,
} from "./commons/LanderConfig";
import { useFetch } from "./commons/useFetch";
import { getCookie, getVisitorIdentifier } from "./commons/HelperFunctions";
import { LanderCookie } from "./commons/Constants";
import { I18nProvider } from "./i18n/I18nProvider";

const errorPageStyle = `body {
  margin: auto;
  padding: 10px;
  background-color: #F3F7FC;
  font-family: 'Arial';
}`;

export const ParkingLander = () => {
  const queryConfig = parseLanderQueryParam(window.location.search);
  // Send the frontend visitor id (pvisitor) to the API on every lander system so
  // experiment bucketing keys on the same id events are tagged with (PARKING-5241;
  // mirrors the ParkWeb behavior from PARKING-5137). Sent as a header, never a query
  // param, to avoid the render/fetch loop from PARKING-5187. getVisitorIdentifier is
  // memoized per page, so the value is stable within a page load.
  const extraHeaders = useMemo(
    () => ({
      "X-Visitor-Id": getVisitorIdentifier(),
      "X-Country": getCookie(LanderCookie.COUNTRY) || "",
    }),
    []
  );
  const { body, err } = useFetch(
    getApiUrl(queryConfig),
    queryConfig,
    extraHeaders
  );

  // Fetch error - event already fired by useFetch
  if (err) {
    return (
      <>
        <style>{errorPageStyle}</style>
        <div id="errorMessage" />
      </>
    );
  }

  // Loading
  if (!body) {
    return null;
  }

  // Always create full config - routing logic decides what to use
  const landerConfig = createLanderConfig(body, queryConfig);

  return (
    <I18nProvider isI18n={ landerConfig.lander?.i18n }>
      <LanderConfigProvider
        landerConfig={ landerConfig }
        queryConfig={ queryConfig }
        targeted={ body.targeted }
      >
        <LanderRouter />
      </LanderConfigProvider>
    </I18nProvider>
  );
};
